import React from 'react';
import { Form, Grid, Checkbox, Button } from 'semantic-ui-react';
import { FemaGoModal, FemaGoTable } from 'app-ui-componentlibrary';
import REST from 'go/requests/rest';
import { Alert } from 'app-ui-componentlibrary/dist/componentLibrary';

export class AddNewGroup extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      checkAll: true,
      groupName: '',
      suspended: false,
      groupNames: [],
      errorMessage: ''
    }
  }


  componentDidMount() {
    this.getAllGroupNames()
  }

  resetFormSelection = () => {
    this.props.categories.map((category) => {
      delete category['checked']
    })
  }

  getAllGroupNames = () => {
    var names = []
    REST.panelReviewV2.getGroupNamesBySession(this.props.token, this.props.sessionId)
    .then(REST.handler.handleResponse)
    .then(res => {
      const names = []
      res.forEach((name) => names.push(name.name))
      this.setState({
        groupNames: names
      })
    })
  }

  showErrorMessage = (message) => {
    return (
      <Alert
              key='failureMessage'
              header={'Error adding a new group'}
              content={message}
              type='error'
              onDismiss={() => this.setState({errorMessage: ''})}
              dismissable
       />
    )
  }

  handleGroupAdd = () => {
    const nameExists = this.state.groupNames.find((name) => name.toLowerCase()  === this.state.groupName.toLowerCase())

    if (nameExists) {
        this.setState({
          errorMessage: 'This group name has been used'
        })
      return
    } else {
      this.setState({
        errorMessage: ''
      })
      this.props.addNewGroup(this.state.groupName, this.state.suspended); 
      this.props.openManageTeamModal(this.props.selectedGroup)
    }
  }

  checkForSelected = () => {
    const checkChecked = this.props.categories.some((category) => {
      return category.checked === true
    })

    return checkChecked ? false : true
  }

  render() {

    return (
      <React.Fragment>
        <FemaGoModal
          title={'Add a new group'}
          open={this.props.manageModalVisible && this.props.modalType === 'add'}
          size='small'
          buttonText="Save & close"
          confirmButton="hidden"
          closeOnDimmerClick='yes'
          confirmAction={() => { this.props.addNewGroup(groupName); this.props.openManageTeamModal(null, 'add') }}
          cancelAction={() => {
            this.setState({errorMessage: ''});
            this.resetFormSelection(); this.props.openManageTeamModal(null, 'add');
            this.setState({checkAll: true});
          }}  
        >
          {!this.props.loading && this.props.selectedGroup != undefined ? (
            <Form>
              <Grid celled>
                <Grid.Row>
                  {
                    this.state.errorMessage
                    ?
                    <Grid.Column width={16}>
                      {this.showErrorMessage(this.state.errorMessage)}
                    </Grid.Column>
                    :
                    null
                  }
                 
                  <Grid.Column width={8}>
                    <small>
                      <strong>Group name:</strong>
                    </small>
                    <br />
                    <Form.Field>
                      <input onChange={(e) => this.setState({
                        groupName: e.target.value
                      })} placeholder='Group Name' />
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <small>
                      <strong>Status:</strong>
                    </small>
                    <br />
                    <Checkbox
                      label={'Inactive'}
                      disabled
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <div className="container_femagotable" >
                      <div className="sidescroll">
                        <FemaGoTable scrollable={10}>
  
                          <FemaGoTable.Header>
                            <FemaGoTable.Row>
                              <FemaGoTable.HeaderCell>
                                <input
                                  id="selectAll"
                                  name="selectAll"
                                  title="select/deselect all"
                                  type="checkbox"
                                  onClick={() => { this.props.selectAllCategories(this.props.categories, this.state.checkAll); 
                                    this.setState({
                                      checkAll: !this.state.checkAll
                                    });
                                  }
                                  }
                                />
                                &nbsp;
                                <label htmlFor="selectAll">Select all</label>
                              </FemaGoTable.HeaderCell>
                              <FemaGoTable.HeaderCell width={'twelve'}>
                                Categories
                              </FemaGoTable.HeaderCell>
                            </FemaGoTable.Row>
                          </FemaGoTable.Header>
                          <FemaGoTable.Body>
                            {this.props.categories &&
                              _.map(this.props.categories, (category, index) => {
                                return (<FemaGoTable.Row key={index}>
                                  <FemaGoTable.TextCell textAlign="left">
                                    <input
                                      type="checkbox"
                                      name={'category_' + index}
                                      value={index}
                                      checked={category && category.checked}
                                      onChange={() => this.props.handleSelectCategory(category)}
                                    />
                                  </FemaGoTable.TextCell>
                                  <FemaGoTable.TextCell width={'twelve'}>
                                    {category?.name}
                                  </FemaGoTable.TextCell>
                                </FemaGoTable.Row>
                                );
                              })}
                          </FemaGoTable.Body>
                        </FemaGoTable>
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <div style={{ marginTop: '50px' }}>
  
              </div>
              <Button
                title={'Save'}
                primary
                className='save-button'
                compact
                disabled={this.checkForSelected()}
                onClick={() => { this.handleGroupAdd() }}
              >Save </Button>
            </Form>
          ) : (
            <div>Loading entities</div>
          )}
        </FemaGoModal>
      </React.Fragment>
    )
  }
  
}
